import { render, staticRenderFns } from "./CreatePhysicalFolder.vue?vue&type=template&id=d97ee1a0&"
import script from "./CreatePhysicalFolder.js?vue&type=script&lang=js&"
export * from "./CreatePhysicalFolder.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports